import { AnswerInfo } from "./answer-info";

export class QuestionInfo {
    public QuestionId: string;
    public QuestionText: string;
    public Answer: AnswerInfo = new AnswerInfo();
    public ValidChoices: AnswerInfo[];
    public Choices: AnswerInfo[];
    public Completed = false;
    public Section: string;
    public Sequence: string;
    public Tags: string;
    public ShowExpandedOnLoad: boolean;
    public States:string[];
    public Type: string;
    public Title: string;
    public errorMessage?: string;
    public Program:string;
  }

  export interface MarketingProspectsConsents {
    Type: string;
    Value: boolean;
  }
